import { render, staticRenderFns } from "./PromoGroups.vue?vue&type=template&id=0358e863"
import script from "./PromoGroups.vue?vue&type=script&lang=js"
export * from "./PromoGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports